import React from "react";
 import  { useState, useEffect } from 'react';
 import { DataGrid } from '@mui/x-data-grid';
 import { configData } from "../config";
 import { Link } from '@mui/material';
 import './classes/AgencyPreviousSubmissions.css';
import SalespersonSidebar from "./SalespersonSidebar";
import { Helmet } from 'react-helmet';
import { useLocation,useNavigate,useSearchParams } from 'react-router-dom';
import Loading from './Loading';



const LookingForAgentWebformResults =() =>{

  const columns = [
  {
    field: 'id',
    headerName: '#',
    cellClassName:'id_column',headerClassName:'id_header',
    sortable: true,
    filterable: false,
    minWidth: 50,
    renderCell: (params) => (
        <Link href={"/node/1080/submission/"+params.row.id} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
            {params.row.id}
        </Link>
    ),
    
  },
  {
    field: 'date_submitted',
    headerName: 'Date Submitted',
    cellClassName:'date_submitted_column',headerClassName:'date_submitted_header',
    sortable: true,
    filterable: false,
    minWidth: 100,
  },
  {
    field: 'name',
    headerName: 'Name',
    cellClassName:'name_column',headerClassName:'name_header',
    sortable: true,
    filterable: false,
    minWidth: 100,
    renderCell: (params) => (
      <>
        {params.row.view_profile ? (
          <Link href={params.row.view_profile} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
            {params.row.name}
          </Link>
        ) : (<>{params.row.name}</>)}
      </>
    ),
  },
  {
    field: 'ip_address',
    headerName: 'IP Address',
    cellClassName:'ip_address_column',headerClassName:'ip_address_header',
    sortable: true,
    filterable: false,
    minWidth: 100,
    
  },
  {
    field: 'operations',
    headerName: 'Operations',
    cellClassName:'operations_column',headerClassName:'operations_header',
    sortable: false,
    filterable: false, // not filterable
    minWidth: 100,
    renderCell: (params) => (
      <>
      <Link href={"/node/1080/submission/"+params.row.id} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.linkText || 'View'}
      </Link>&nbsp;&nbsp;
      { userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) && 
        <Link href={"/node/1080/submission/"+params.row.id+"/edit"} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.linkText || 'Edit'}
      </Link>
       } &nbsp;&nbsp;
       { (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) &&
        <Link href={"/node/1080/submission/"+params.row.id+"/delete"} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.linkText || 'Delete'}
      </Link>
      }
      </>
    ),
  },
];
  /* Pagination, filter config starts here */
    const [rows, setRows] = React.useState([]);
    // const [pageTitle, setPageTitle] = React.useState({});
    const [rowCount, setRowCount] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });
    const [isLoading, setIsLoading] = useState(true);
    const app_url = configData.APP_URL;
    const location  = useLocation();
    const[successAthleteMessage,setSuccessAthleteMessage] = useState('');
    const successMessage = location.state?.message; // Access the message
    // window.history.replaceState({}, '');
    const domainName = window.location.hostname;
    const loggedin_drupal_uid = localStorage.getItem('drupal_uid');    
    const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);

    useEffect(() => {
      if (successMessage) {
        setSuccessAthleteMessage(successMessage);
        window.history.replaceState({}, '');
      }
    }, [successMessage, location.state]);

    React.useEffect(() => {
        const fetchData = async () => {
        try {
        const response = await fetch(app_url+'smwwathlete/retrievefullsubmissions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
            page: paginationModel.page,
            pageSize: paginationModel.pageSize,
            sortModel,
            filterModel,
            loggedin_drupal_uid:loggedin_drupal_uid
            }),
        });
        const data = await response.json();
        console.log(data.data.rows);
        setRows(data.data.rows);
        setRowCount(data.data.totalRowCount); // Server should return totalRowCount
        // setPageTitle(data.data.email);
        // console.log("Type of totalRowCount:", typeof data.data.totalRowCount);
        }  catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setIsLoading(false); // Set loading to false after fetch completes (success or error)
            }
    

        };

        fetchData();
    }, [paginationModel, sortModel, filterModel]); // Re-fetch data when these change

    useEffect(() => {
            getuserloggedinroles()
            }, []);

    async function getuserloggedinroles() {
   
         try {
            const response = await fetch(
                app_url+'viewprofile/getuserloggedinrolesid',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
             // setUserLoggedInId(responsedata.data.user); 
              setUserLoggedInRoles(responsedata.data.roles);
            } 
        } catch (err) {
            
         }
       
  }
 
    return(
      <>
        {isLoading ? (
            <Loading />
        ) : (
        <div id="main">
            <div className="left"></div>
            <>
                <div className="center left-center">
                    <div className="agency-previous-submissions-container">
                      <Helmet><title>Submissions</title></Helmet>
                        {successAthleteMessage && (
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successAthleteMessage}
                        </div>
                        )}
                        <p>&nbsp;</p>
                        <div>Showing 1 - {rowCount} of {rowCount}</div>
                        <div className="agency-previous-submissions-view-content">
                            <table className="agency-previous-submissions-view-table">
                                <div style={{ width: '100%' }}>
                                    <DataGrid
                                        rows={rows}
                                        columns={columns}
                                        rowCount={rowCount}
                                        paginationMode="server"
                                        sortingMode="server"
                                        filterMode="server"
                                        paginationModel={paginationModel}
                                        onPaginationModelChange={setPaginationModel}
                                        sortModel={sortModel}
                                        onSortModelChange={setSortModel}
                                        filterModel={filterModel}
                                        onFilterModelChange={setFilterModel}
                                        pageSizeOptions={[5, 10, 25,50]}
                                        getRowId={() => crypto.randomUUID()}
                                        getRowHeight={() => 'auto'}
                                        disableColumnFilter 
                                        disableColumnResize={true}
                                    />
                                </div>
                            </table>
                            {/* {rowCount === "0" && 
                              <p>
                                There are no previous submissions for this form. <a href={"https://"+configData.RSMWW_AGENCY_DOMAIN+"/lookingforagent.php"}>View this form</a>.
                              </p>
                            } */}
                        </div>
                    </div>
                </div>
            </>
            <div className="right">
              <SalespersonSidebar />
            </div>
        </div>
       )}
    </>  
    );
};

export default LookingForAgentWebformResults;